import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { StickyCta } from '../components/StickyCta';
import { HeroSection } from '../components/sections/HeroSection';
import { VisualProofSection } from '../components/sections/VisualProofSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { IncludedSection } from '../components/sections/IncludedSection';
import { PrintPackSection } from '../components/sections/PrintPackSection';
import { SituationsSection } from '../components/sections/SituationsSection';
import { OfferSection } from '../components/sections/OfferSection';
import { FaqSection } from '../components/sections/FaqSection';
import { FinalCtaSection } from '../components/sections/FinalCtaSection';
export function SalesPage() {
  return <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-night pb-20 pt-16 font-sans text-cream md:pb-0" data-id="element-222" data-mp="3qqjmqdg9zzvx">
      <SiteHeader data-id="element-223" data-mp="3ajgj3347xw0l" />
      <main data-id="element-224" data-mp="3ak02ko9iosgq">
        <HeroSection data-id="element-225" data-mp="3aki5u4ulk6y5" />
        <VisualProofSection data-id="element-226" data-mp="3al1cgpesr8wv" />
        <ProblemSection data-id="element-227" data-mp="35t0073hmpi6u" />
        <SolutionSection data-id="element-228" data-mp="35sq9teso990m" />
        <IncludedSection data-id="element-229" data-mp="35rf9joyfqje9" />
        <PrintPackSection data-id="element-230" data-mp="35r6ubqeub1zw" />
        <SituationsSection data-id="element-231" data-mp="30tdq32x3ki29" />
        <OfferSection data-id="element-232" data-mp="30uoth1mmrnsu" />
        <FaqSection data-id="element-233" data-mp="30u6n3c697t77" />
        <FinalCtaSection data-id="element-234" data-mp="30rkklqy803vu" />
      </main>
      <StickyCta data-id="element-235" data-mp="2vvlpzlmatpmz" />
    </div>;
}